export const getShareCardKey = (card) => {
  if (!card) return '';
  if (card.type === 'content-share') return `cs:${card.tileId}`;
  if (card.type === 'remote-video') return `rv:${card.tileId}`;
  if (card.type === 'local-camera') return 'lc:local';
  if (card.type === 'profile') {
    const user = card.user || {};
    return `pf:${user.participantId || user.id || user.attendeeId || user.fullName || user.name || 'unknown'}`;
  }
  return '';
};

export const buildShareCards = ({
  contentTileIds = [],
  remoteVideoTiles = [],
  localCameraOn = false,
  cameraOffUsers = [],
}) => ([
  ...contentTileIds.map((tileId) => ({ type: 'content-share', tileId })),
  ...remoteVideoTiles.map((tileId) => ({ type: 'remote-video', tileId })),
  ...(localCameraOn ? [{ type: 'local-camera' }] : []),
  ...cameraOffUsers.map((user) => ({ type: 'profile', user })),
]);

export const buildNormalCards = ({
  remoteVideoTiles = [],
  localCameraOn = false,
  cameraOffUsers = [],
}) => ([
  ...remoteVideoTiles.map((tileId) => ({ type: 'remote-video', tileId })),
  ...(localCameraOn ? [{ type: 'local-camera' }] : []),
  ...cameraOffUsers.map((user) => ({ type: 'profile', user })),
]);
